module.exports = "/images/automated-tax-calculations@3x.png?61347c5d505073097dd8822b407462a8";